import { Icon } from "@components";
import { FC } from "react";
interface Props {
    bymESource: string
}
export const EmptyState: FC<Props> = ({ bymESource }) => (
    <div
        className="flex flex-col items-center 
            justify-center h-full text-center 
            p-6 text-gray-500"
    >
        <Icon iconName="MessageSquare" size={48} />
        <h3 className="text-lg font-medium mb-2">Commencez une conversation</h3>
        <p className="text-sm">Posez une question pour démarrer la discussion.</p>
        <img
            width={50}
            alt="Chat Avatar"
            src={bymESource}
        />
    </div>
);